import { EditorNodeName } from "@/enums/customAttributes";

import type { EditorNode } from "@/models/TextEditor";

export const BLANK_NODES: Record<EditorNodeName, EditorNode> = {
  uncategorized: {
    type: EditorNodeName.uncategorized,
    atomic: false,
    isOperator: false,
    isOperand: true,
    content: "",
    error: {},
  },
  attribute: {
    type: EditorNodeName.attribute,
    content: "",
    atomic: true,
    isOperator: false,
    isOperand: true,
    context: undefined,
    isSelected: false,
    error: {},
  },
  function: {
    type: EditorNodeName.function,
    atomic: false,
    isOperator: true,
    isOperand: true,
    content: "",
    error: {},
  },
  operator: {
    type: EditorNodeName.operator,
    atomic: false,
    isOperator: true,
    isOperand: false,
    content: "",
    error: {},
  },
  unrecognized: {
    type: EditorNodeName.unrecognized,
    atomic: false,
    isOperator: false,
    isOperand: true,
    content: "",
    error: {},
  },
  separator: {
    type: EditorNodeName.separator,
    atomic: false,
    isOperator: false,
    isOperand: false,
    content: "",
    error: {},
  },
  number: {
    type: EditorNodeName.number,
    atomic: false,
    isOperator: false,
    isOperand: true,
    content: "",
    error: {},
  },
  parenthesis: {
    type: EditorNodeName.parenthesis,
    atomic: false,
    isOperator: false,
    isOperand: false,
    content: "",
    context: undefined,
    error: {},
  },
  regex: {
    type: EditorNodeName.regex,
    atomic: false,
    isOperator: false,
    isOperand: true,
    content: "",
    error: {},
  },
  attributeOption: {
    type: EditorNodeName.attributeOption,
    atomic: true,
    isOperator: false,
    isOperand: true,
    content: "",
    error: {},
  },
};

export const DELIMITERS = [
  "+",
  "-",
  "*",
  "/",
  "(",
  ")",
  ",",
  "[",
  "]",
  ">",
  "<",
  "!=",
  "==",
  "&&",
  "||",
  "%",
  "^",
  "<=",
  ">=",
];

export const OPENING_PARENTHESIS = ["(", "["];

export const CLOSING_PARENTHESIS = [")", "]"];

export const BRACKET_COLORS = [
  "text-blue-700",
  "text-green-700",
  "text-yellow-300",
  "text-purple-700",
  "text-gray-700",
  "text-pink-700",
];

export const CONTEXT_OPENING_BRACKET = "{";
export const CONTEXT_CLOSING_BRACKET = "}";
export const ATTRIBUTE_PREFIX_CHAR = ":";
export const STRING_CHARS = ['"', "'", "’"];

export const CUSTOM_ATTRIBUTE_ID = "custom";

export const IGNORED_INPUT_CHARS = ["{", "}"] as const;
